import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
//import "./example-styles.css";
//import "./styles.css";
//import { Responsive, WidthProvider } from "react-grid-layout";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
//import NewWindow from "react-new-window";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import detectZoom from "detect-zoom";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import Fab from "@mui/material/Fab";
import NavigationIcon from "@mui/icons-material/Navigation";
import AddIcon from "@mui/icons-material/Add";
import ConsultaServicio from "./ConsultaServicio";
import NotasServicio from "./NotasServicio";
import ResumenServicio from "./ResumenServicio";
import ResumenMoviles from "./ResumenMoviles";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
//import classNames from "classnames";
import { classNames } from "primereact/utils";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import clsx from "clsx";
import { Tooltip } from "primereact/tooltip";
import { Badge } from "primereact/badge";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import HouseIcon from "@mui/icons-material/House";
import AdjustIcon from "@mui/icons-material/Adjust";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import FlagIcon from "@mui/icons-material/Flag";
import { Dialog } from "primereact/dialog";
import { Tag } from "primereact/tag";
import { ScrollPanel } from "primereact/scrollpanel";
import "../../../assets/css/ScrollPanelDemo.css";
import "../../../assets/css/DataTableDemo.css";
import "../../../assets/css/DialogDemo.css";
import "../../../assets/css/DropDown.css";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { SelectButton } from "primereact/selectbutton";
import { SplitButton } from "primereact/splitbutton";
import MoodBadIcon from "@mui/icons-material/MoodBad";
import { MultiSelect } from "primereact/multiselect";
import { saveAs } from "file-saver";
import { styled } from "@mui/material/styles";
import { Navigate, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import { useParams } from "react-router-dom";
import axios from "axios";
import { TextareaAutosize } from "@mui/base";
import { Dropdown } from "primereact/dropdown";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import logo4 from "../../../assets/images/masteredlogo.png";
import logo5 from "../../../assets/images/maxsalud.png";
import logo6 from "../../../assets/images/ambulanceapp.png";
import Autocomplete from "@mui/material/Autocomplete";
import { DataScroller } from "primereact/datascroller";
import { DataView } from "primereact/dataview";
import packageJson from "../../../../package.json";

export default function Telemedicina(props) {
  //const classes = useStyles();
  //const theme = useTheme();

  const sexos = [
    { nombre: "M", dataKey: "m" },
    { nombre: "F", dataKey: "f" },
    { nombre: "O", dataKey: "o" },
  ];

  const [value, setValue] = useState();
  const [filter, setFilter] = useState(null);
  const [loop, setLoop] = useState(null);
  const [resolution, setResolution] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [visibleDatos, setVisibleDatos] = useState(false);
  const [visibleReceta1, setVisibleReceta1] = useState(false);
  const [visibleReceta2, setVisibleReceta2] = useState(false);
  const [visibleIndicaciones, setVisibleIndicaciones] = useState(false);
  const [visibleDiagnostico, setVisibleDiagnostico] = useState(false);
  const [visibleGestion, setVisibleGestion] = useState(false);
  useState(false);
  const toast = useRef(null);
  const alertContext = useContext(AlertContext);
  const [medicamentoElegido, setMedicamentoElegido] = useState(null);
  const [cantidadMedicamento, setCantidadMedicamento] = useState(null);
  const [presentacionElegida, setPresentacionElegida] = useState(null);
  const [medicamentosRecetas, setMedicamentosRecetas] = useState([]);
  const [servicioTelemedicinaNuevo, guardarServicioTelemedicinaNuevo] =
    useState(null);
  const acMotivo = useRef(null);
  const motivoEnvio = "SE ENVIA MOVIL PRESENCIAL";

  let navigate = useNavigate();

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    configuracion,
    medicamentos,
    presentaciones,
    movil,
    diagnosticos,
    medico,
    recetas,
    coseguroServicio,
    motivosConsultas,
    obrasSocialesMedicas,
    obtenerObrasSocialesRecetario,
    obtenerMedicamentosTelemedicina,
    obtenerConfiguracion,
    obtenerMovil,
    obtenerMedicoRecetario,
    obtenerDiagnosticosTelemedicina,
    obtenerRecetas,
    generarIndicacionesTelemedicina,
    anularRecetas,
    enviarRecetas,
    obtenerMotivosConsultas,
    obtenerCoseguroServicio,
  } = configuracionContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    servicioTelemedicina,
    servicioTelemedicinaActivos,
    notas,
    titular,
    obtenerServicioTelemedicina,
    obtenerNotasTelemedicina,
    guardarServicioTelemedicina,
    cerrarServicioTelemedicina,
    buscarTitular,
  } = serviciosContext;

  let { id } = useParams();

  useEffect(() => {
    let version = localStorage.getItem("version");
    if (version != packageJson.version) {
      if ("caches" in window) {
        caches.keys().then((names) => {
          // Delete all the cache files
          names.forEach((name) => {
            caches.delete(name);
          });
        });

        // Makes sure the page reloads. Changes are only visible after you refresh.
        window.location.reload(true);
      }

      localStorage.clear();
      localStorage.setItem("version", packageJson.version);
    }
  }, []);

  useEffect(() => {
    if (id) {
      obtenerServicioTelemedicina({ servicioId: id });
      obtenerNotasTelemedicina({ servicioId: id });
    }
  }, [id]);

  useEffect(() => {
    obtenerObrasSocialesRecetario();
    obtenerMedicamentosTelemedicina();
    obtenerConfiguracion();
    obtenerDiagnosticosTelemedicina();
    obtenerMotivosConsultas({ todos: false });
    //localStorage.removeItem("motivoConsultaId");
    //localStorage.removeItem("diagnosticoId");
  }, []);

  useEffect(() => {
    if (servicioTelemedicina && servicioTelemedicina.derivadoId) {
      obtenerMovil({ idMovil: servicioTelemedicina.derivadoId });
    }
  }, [servicioTelemedicina]);

  useEffect(() => {
    if (movil) {
      obtenerMedicoRecetario({ recetarioId: movil.recetarioId });
    }
  }, [movil]);

  useEffect(() => {
    setVisibleDatos(false);
    setVisibleReceta1(false);
    setVisibleReceta2(false);
    setVisibleIndicaciones(false);
    setVisibleDiagnostico(false);
    setVisibleGestion(false);
  }, []);

  const exitClick = (e) => {
    navigate(`/`);
  };

  const llamadoCelular = async () => {
    return (
      <a href={"tel:+549" + servicioTelemedicina.celular}>
        {servicioTelemedicina.celular}
      </a>
    );
  };

  const confirmarRecepcion = async () => {
    if (servicioTelemedicinaActivos.length > 0) {
      toast.current.show({
        severity: "warn",
        summary: "Telemedicina",
        detail: `Para iniciar un nuevo servicio debe finalizar el servicio ${servicioTelemedicinaActivos[0].id} del paciente ${servicioTelemedicinaActivos[0].nombre}.`,
        life: 5000,
      });
      return;
    }

    localStorage.removeItem("diagnosticoId");
    localStorage.removeItem("detalleDiagnostico");
    localStorage.removeItem("indicaciones");
    localStorage.removeItem("motivoConsultaId");

    let datos = {
      servicioId: servicioTelemedicina.id,
      movilId: servicioTelemedicina.derivadoId,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    await axios
      .post(
        process.env.REACT_APP_BACKEND_URL +
          "/api/servicios/confirmarrecepciontelemedicina",
        datos,
        config
      )
      .then(function (response) {
        //console.log(response);
        toast.current.show({
          severity: "success",
          summary: "Telemedicina",
          detail: "Se ha confirmado la recepción del servicio correctamente.",
          life: 3000,
        });
      });

    setTimeout(() => {
      obtenerServicioTelemedicina({ servicioId: id });
    }, 2000);
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  const itemTemplate = (rowData, options) => {
    const icon = "pi pi-trash";
    return (
      <Button
        type="button"
        icon={icon}
        severity={"danger"}
        className="p-button-sm p-button-text"
        onClick={() => eliminarMedicamento(rowData, options.rowIndex)}
      />
    );
  };

  const prolongadoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">T. Prolongado</span>
        <Checkbox checked={rowData.tratamientoProlongado}></Checkbox>
      </Fragment>
    );
  };

  const duplicadoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Duplicado</span>
        <Checkbox checked={rowData.duplicado}></Checkbox>
      </Fragment>
    );
  };

  const respetarTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Respetar Marca</span>
        <Checkbox checked={rowData.respetarMarca}></Checkbox>
      </Fragment>
    );
  };

  const agregarMedicamento = () => {
    const copyArray = [...medicamentosRecetas];

    copyArray.push({
      medicamento:
        medicamentoElegido.marcaComercial +
        " - " +
        medicamentoElegido.principioActivo,
      presentacion: presentacionElegida.presentacion,
      cantidad: cantidadMedicamento,
      code: presentacionElegida.code,
      tratamientoProlongado: servicioTelemedicina.tratamientoProlongado,
      duplicado: servicioTelemedicina.duplicado,
      respetarMarca: servicioTelemedicina.respetarMarca,
    });

    setMedicamentosRecetas(copyArray);
    //setVisible(false);
    let elem = document.getElementById("cancelarMedicamento");
    if (elem) {
      setTimeout(() => {
        elem.click();
      }, 100);
    }
  };

  const eliminarMedicamento = (data, index) => {
    medicamentosRecetas.splice(index, 1);
    let elem = document.getElementById("cancelarMedicamento");
    if (elem) {
      elem.click();
    }
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return year + "-" + month + "-" + day;
  }

  const aceptarClick = async (e) => {
    let medicines = [];

    for (var i = 0; i < medicamentosRecetas.length; i++) {
      medicines.push({
        externalId: medicamentosRecetas[i].code,
        quantity: Number(medicamentosRecetas[i].cantidad),
        genericOnly: !medicamentosRecetas[i].respetarMarca,
        longTerm: medicamentosRecetas[i].tratamientoProlongado,
        requiresDuplicate: medicamentosRecetas[i].duplicado,
      });
    }

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      `Bearer ${process.env.REACT_APP_RECETARIO_TOKEN}`
    );

    var raw = JSON.stringify({
      userId: Number(movil.recetarioId),
      date: servicioTelemedicina.fpasado.substring(0, 10),
      patient: {
        healthInsurance: servicioTelemedicina.obraSocial.trim(),
        insuranceNumber: servicioTelemedicina.nroObraSocial
          ? servicioTelemedicina.nroObraSocial.trim()
          : "",
        name: servicioTelemedicina.nombres.trim(),
        surname: servicioTelemedicina.apellido.trim(),
        documentNumber: servicioTelemedicina.numeroDocumento.trim(),
        //email: "prueba@recetario.com.ar",
        phone: servicioTelemedicina.celular ? servicioTelemedicina.celular : "",
        gender: servicioTelemedicina.sexo.toLowerCase(),
        birthDate: servicioTelemedicina.nacimiento,
      },
      method: "vademecum",
      diagnosis: servicioTelemedicina.detalleDiagnostico,
      medicines,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    /*    
      fetch("https://external-api.recetario.com.ar/prescriptions", requestOptions)
     .then(response => response.text())
     .then(result => console.log(result))
     .catch(error => console.log('error', error));
      */

    try {
      let response = await fetch(
        "https://external-api.recetario.com.ar/prescriptions",
        requestOptions
      );

      if (response.ok) {
        toast.current.show({
          severity: "success",
          summary: "Recetas",
          detail: "La receta se ha generado correctamente.",
          life: 3000,
        });

        const json = await response.json();

        let url = json.url;
        let id = json.id;
        //window.open(url, "_blank");

        //let idMedico = medicos.find(
        //  (element) => element.recetarioId === Number(medicoId)
        //).id;

        let datos = {
          movilId: movil.id,
          servicioId: servicioTelemedicina.id,
          telefono: servicioTelemedicina.celular,
          //email: pacienteSeleccionado.email,
          //enviarWhatsApp: pacienteSeleccionado.enviarWhatsApp,
          //enviarCorreo: pacienteSeleccionado.enviarCorreo,
          url,
          id,
        };

        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        await axios
          .post(
            process.env.REACT_APP_BACKEND_URL +
              "/api/configuracion/agregarreceta",
            datos,
            config
          )
          .then(function (response) {
            console.log(response);
          });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Recetas",
          detail: "Hubo un error al generar la receta.",
          life: 3000,
        });
      }
    } catch (error) {
      console.error(error.message);
    }

    /*
    setTimeout(() => {
      onHide();
    }, 5000);
    */
  };

  const onHide = (e) => {
    window.location.reload("/telemedicina/0");
  };

  const verificarReposo = (data) => {
    let index = data.toLowerCase().search("reposo");
    if (index !== -1) {
      toast.current.show({
        severity: "warn",
        summary: "Receta",
        detail: "Por favor cambiar la palabra reposo.",
        life: 3000,
      });
      return;
    }
  };

  const confirmarAnular = (rowData) => {
    confirmDialog({
      message:
        rowData.tipo === "RECETA"
          ? "Esta seguro de anular la receta ?"
          : "Esta seguro de anular las indicaciones ?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFuncAnular(rowData),
    });
  };

  const acceptFuncAnular = (data) => {
    anularRecetas({ id: data.id, recetaId: data.recetaId });
    setTimeout(() => {
      obtenerRecetas({ servicioId: servicioTelemedicina.id });
    }, 1000);
  };

  const confirmarEnviar = () => {
    confirmDialog({
      message: "Confirma envío de recetas e indicaciones",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFuncEnviar(),
    });
  };

  const acceptFuncEnviar = () => {
    if (
      servicioTelemedicina &&
      (!servicioTelemedicina.celular || servicioTelemedicina.celular === "")
    ) {
      toast.current.show({
        severity: "warn",
        summary: "Receta",
        detail: "Debe cargar un celular.",
        life: 3000,
      });
      return;
    }

    enviarRecetas({
      servicioId: servicioTelemedicina.id,
      celular: servicioTelemedicina.celular,
    });
  };

  const confirmarCerrar = () => {
    //console.log(afiliado, value)

    let motivo = diagnosticos.find(
      (item) => item.id === servicioTelemedicina.diagnosticoId
    ).nombre;

    confirmDialog({
      message:
        motivo !== motivoEnvio
          ? `Confirma cierre del servicio ?`
          : `Se va a generar un nuevo indicativo de color ${servicioTelemedicinaNuevo.color}. Confirma cierre del servicio ?`,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFuncCerrar(),
    });
  };

  const acceptFuncCerrar = () => {
    cerrarServicioTelemedicina({
      servicioTelemedicina,
      destinatario: configuracion.destinatario,
      servicioTelemedicinaNuevo,
      coseguroServicio,
    });
    setTimeout(() => {
      onHide();
    }, 2000);
  };

  const itemTemplateGestion = (data) => {
    return (
      <div className="col-12">
        <div className="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
          <div className="flex flex-column lg:flex-row justify-content-between align-items-center xl:align-items-start lg:flex-1 gap-4">
            <div className="flex flex-column align-items-center lg:align-items-start gap-3">
              <div
                className="flex flex-column gap-1"
                style={{ fontWeight: "bold", marginLeft: "1vw" }}
              >
                <div className="text-2xl font-bold text-900">{data.fecha}</div>
                <div className="text-700">{data.tipo}</div>
                <Grid container spacing={0} style={{ padding: "0" }}>
                  <Grid item xs={6} md={6}>
                    <Button
                      icon="pi pi-search"
                      label="Ver"
                      severity="success"
                      style={{ marginTop: "2vw", marginBottom: "2vw" }}
                      onClick={() => {
                        data.tipo === "RECETA"
                          ? window.open(data.url, "_blank")
                          : window.open(data.url2, "_blank");
                      }}
                    ></Button>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Button
                      icon="pi pi-trash"
                      label="Anular"
                      severity="danger"
                      style={{ marginTop: "2vw", marginLeft: "2vw" }}
                      onClick={() => {
                        confirmarAnular(data);
                      }}
                    ></Button>
                  </Grid>
                </Grid>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // INICIO

  if (
    !servicioTelemedicinaNuevo &&
    servicioTelemedicina &&
    servicioTelemedicina.motivoConsultaId &&
    motivosConsultas &&
    motivosConsultas.length > 0 &&
    servicioTelemedicina.color === "BLANCO"
  ) {
    let motivoId = Number(localStorage.getItem("motivoConsultaId"));
    let motivoConsultaId = null;
    let color = null;

    if (!isNaN(motivoId) && motivoId !== 0) {
      let index = motivosConsultas.findIndex((item) => item.id === motivoId);
      color = motivosConsultas[index].color;
      motivoConsultaId = motivoId;
      guardarServicioTelemedicinaNuevo({
        ...servicioTelemedicinaNuevo,
        motivoConsultaId,
        color,
      });
    }
  }

  if (servicioTelemedicina && !titular) {
    buscarTitular({ titularId: servicioTelemedicina.titularId });
  }

  // FIN

  //console.log(servicioTelemedicinaNuevo);
  //console.log(diagnosticos);

  return (
    <Fragment>
      <Toast ref={toast} />
      <ConfirmDialog />
      <Fragment>
        <Grid container spacing={0} style={{ padding: "0" }}>
          <Grid item xs={4} md={4}>
            {configuracion && configuracion.destinatario === 4 ? (
              <img
                src={logo4}
                alt="Logo"
                height="50"
                style={{ marginLeft: "2em", marginTop: "0.2em" }}
              />
            ) : null}
            {configuracion && configuracion.destinatario === 5 ? (
              <img
                src={logo5}
                alt="Logo"
                height="50"
                style={{ marginLeft: "2em", marginTop: "0.2em" }}
              />
            ) : null}
            {configuracion && configuracion.destinatario === 6 ? (
              <img
                src={logo6}
                alt="Logo"
                height="50"
                style={{ marginLeft: "2em", marginTop: "0.2em" }}
              />
            ) : null}
          </Grid>
          <Grid item xs={8} md={8}>
            <h2 style={{ textAlign: "center" }}>Telemedicina</h2>
          </Grid>
        </Grid>

        {/*  
        {!servicioTelemedicina && id !== 0 ? (
          <h2 style={{ textAlign: "center" }}>Servicio Inexistente</h2>
        ) : null}

        {!servicioTelemedicina && id === 0 ? (
          <h2 style={{ textAlign: "center" }}>Servicio Cerrado</h2>
        ) : null}
        */}

        {servicioTelemedicina &&
        servicioTelemedicina.estado === "PASADO" &&
        !visibleDatos &&
        !visibleReceta1 &&
        !visibleReceta2 &&
        !visibleIndicaciones &&
        !visibleDiagnostico &&
        !visibleGestion ? (
          <Grid container spacing={0} style={{ padding: "0" }}>
            <Grid item xs={6} md={6}>
              <Button
                type="button"
                label="Confirmar Recepción"
                icon="pi pi-check"
                style={{
                  marginLeft: "2vw",
                }}
                className="p-button-success"
                onClick={() => {
                  confirmarRecepcion();
                }}
              />
            </Grid>
          </Grid>
        ) : null}

        {servicioTelemedicina &&
        servicioTelemedicina.estado === "LLEGADA" &&
        !visibleDatos &&
        !visibleReceta1 &&
        !visibleReceta2 &&
        !visibleIndicaciones &&
        !visibleDiagnostico &&
        !visibleGestion ? (
          <Grid container spacing={0} style={{ padding: "0" }}>
            <Grid item xs={6} md={6}>
              <Button
                label="Datos del Paciente"
                icon="pi pi-search"
                style={{
                  marginLeft: "2vw",
                  marginRight: "2vw",
                }}
                disabled={!servicioTelemedicina}
                className="p-button-info"
                onClick={() => {
                  setVisibleDatos(true);
                  setVisibleReceta1(false);
                  setVisibleReceta2(false);
                }}
              />
              <Button
                id="hideCerrar"
                label="Hide"
                style={{ display: "none" }}
                onClick={() => confirmarCerrar()}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <a href={"tel:+549" + servicioTelemedicina.celular}>
                <Button
                  label="Llamado al Celular"
                  icon="pi pi-phone"
                  style={{
                    marginLeft: "2vw",
                    marginRight: "2vw",
                  }}
                  disabled={!servicioTelemedicina}
                  className="p-button-info"
                />
              </a>
            </Grid>
            <Grid item xs={6} md={6}>
              <Button
                label="Carga de Diagnóstico"
                icon="pi pi-pencil"
                style={{
                  marginLeft: "2vw",
                  marginRight: "2vw",
                  marginTop: "2vw",
                }}
                disabled={!servicioTelemedicina}
                className="p-button-info"
                onClick={() => {
                  guardarServicioTelemedicina({
                    ...servicioTelemedicina,
                    diagnosticoId: Number(
                      localStorage.getItem("diagnosticoId")
                    ),
                    detalleDiagnostico:
                      localStorage.getItem("detalleDiagnostico"),
                  });
                  guardarServicioTelemedicinaNuevo({
                    ...servicioTelemedicinaNuevo,
                    motivoConsultaId: Number(
                      localStorage.getItem("motivoConsultaId")
                    ),
                  });
                  setVisibleDiagnostico(true);
                }}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <Button
                label="Generación de Recetas"
                icon="pi pi-align-left"
                style={{
                  marginLeft: "2vw",
                  marginRight: "2vw",
                  marginTop: "2vw",
                }}
                disabled={!servicioTelemedicina}
                className="p-button-info"
                onClick={() => {
                  if (
                    servicioTelemedicina &&
                    (!servicioTelemedicina.diagnosticoId ||
                      !servicioTelemedicina.detalleDiagnostico)
                  ) {
                    toast.current.show({
                      severity: "warn",
                      summary: "Receta",
                      detail: "Primero debe cargar el diagnóstico.",
                      life: 3000,
                    });
                    return;
                  }

                  if (
                    !servicioTelemedicina.apellido &&
                    !servicioTelemedicina.nombres
                  ) {
                    let espacio = servicioTelemedicina.nombre.search(" ");
                    let caracteres = servicioTelemedicina.nombre.length;
                    const nombre = servicioTelemedicina.nombre;
                    servicioTelemedicina.apellido = nombre.substring(
                      0,
                      espacio
                    );
                    servicioTelemedicina.nombres = nombre.substring(
                      espacio + 1,
                      caracteres
                    );
                  }
                  //servicioTelemedicina.nacimiento = formatDate(servicioTelemedicina.nacimiento)
                  setVisibleReceta1(true);
                }}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <Button
                label="Generación de Indicaciónes"
                icon="pi pi-align-left"
                style={{
                  marginLeft: "2vw",
                  marginRight: "2vw",
                  marginTop: "2vw",
                }}
                disabled={!servicioTelemedicina}
                className="p-button-info"
                onClick={() => {
                  //servicioTelemedicina.nacimiento = formatDate(servicioTelemedicina.nacimiento)

                  if (
                    servicioTelemedicina &&
                    (!servicioTelemedicina.diagnosticoId ||
                      !servicioTelemedicina.detalleDiagnostico)
                  ) {
                    toast.current.show({
                      severity: "warn",
                      summary: "Receta",
                      detail: "Primero debe cargar el diagnóstico.",
                      life: 3000,
                    });
                    return;
                  }

                  guardarServicioTelemedicina({
                    ...servicioTelemedicina,
                    indicaciones: localStorage.getItem("indicaciones"),
                  });

                  setVisibleDatos(false);
                  setVisibleReceta1(false);
                  setVisibleReceta2(false);
                  setVisibleIndicaciones(true);
                }}
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <Button
                label="Gestión de Documentos"
                icon="pi pi-file-pdf"
                style={{
                  marginLeft: "2vw",
                  marginRight: "2vw",
                  marginTop: "2vw",
                }}
                disabled={!servicioTelemedicina}
                className="p-button-info"
                onClick={() => {
                  //servicioTelemedicina.nacimiento = formatDate(servicioTelemedicina.nacimiento)
                  setVisibleDatos(false);
                  setVisibleReceta1(false);
                  setVisibleReceta2(false);
                  obtenerRecetas({ servicioId: id });
                  setTimeout(() => {
                    setVisibleGestion(true);
                  }, 1000);
                }}
              />
            </Grid>

            <Grid item xs={3} md={3} />
            <Grid item xs={6} md={6}>
              <Button
                label="Cierre del Servicio"
                icon="pi pi-check"
                style={{
                  marginLeft: "2vw",
                  marginRight: "2vw",
                  marginTop: "2vw",
                }}
                disabled={!servicioTelemedicina}
                className="p-button-info"
                onClick={() => {
                  //servicioTelemedicina.nacimiento = formatDate(servicioTelemedicina.nacimiento)

                  if (
                    !servicioTelemedicina ||
                    servicioTelemedicina.diagnosticoId === undefined ||
                    servicioTelemedicina.diagnosticoId === null ||
                    servicioTelemedicina.diagnosticoId === "" ||
                    servicioTelemedicina.diagnosticoId === 0
                  ) {
                    toast.current.show({
                      severity: "warn",
                      summary: "Telemedicina",
                      detail: "Primero debe cargar el diagnóstico.",
                      life: 3000,
                    });
                    return;
                  }

                  let motivo = diagnosticos.find(
                    (item) => item.id === servicioTelemedicina.diagnosticoId
                  ).nombre;

                  if (
                    !servicioTelemedicina ||
                    servicioTelemedicina.detalleDiagnostico === undefined ||
                    servicioTelemedicina.detalleDiagnostico === null ||
                    servicioTelemedicina.detalleDiagnostico === ""
                  ) {
                    toast.current.show({
                      severity: "warn",
                      summary: "Telemedicina",
                      detail: "Primero debe cargar el detalle del diagnóstico.",
                      life: 3000,
                    });
                    return;
                  }

                  if (
                    servicioTelemedicina &&
                    motivo === motivoEnvio &&
                    (!servicioTelemedicinaNuevo ||
                      servicioTelemedicinaNuevo.motivoConsultaId ===
                        undefined ||
                      servicioTelemedicinaNuevo.motivoConsultaId === null ||
                      servicioTelemedicinaNuevo.motivoConsultaId === 0 ||
                      servicioTelemedicinaNuevo.motivoConsultaId === "" ||
                      isNaN(servicioTelemedicinaNuevo.motivoConsultaId) ||
                      servicioTelemedicinaNuevo.color === undefined ||
                      servicioTelemedicinaNuevo.color === null ||
                      servicioTelemedicinaNuevo.color === "")
                  ) {
                    toast.current.show({
                      severity: "warn",
                      summary: "Telemedicina",
                      detail:
                        "Debe cargar un motivo de consulta para este diagnóstico.",
                      life: 3000,
                    });
                    return;
                  }

                  if (
                    servicioTelemedicinaNuevo &&
                    servicioTelemedicinaNuevo.motivoConsultaId &&
                    servicioTelemedicinaNuevo.color
                  ) {
                    let index = motivosConsultas.findIndex(
                      (item) =>
                        item.id === servicioTelemedicinaNuevo.motivoConsultaId
                    );
                    let servicioId = motivosConsultas[index].servicioId;
                    let servicioNombre = motivosConsultas[index].nombre;

                    obtenerCoseguroServicio({
                      servicio: servicioId,
                      afiliado: servicioTelemedicina,
                      titular,
                      nombre: servicioNombre,
                    });
                  }

                  setVisibleDatos(false);
                  setVisibleReceta1(false);
                  setVisibleReceta2(false);
                  let elem = document.getElementById("hideCerrar");
                  if (elem) {
                    setTimeout(() => {
                      elem.click();
                    }, 1000);
                  }

                  //confirmarCerrar();
                }}
              />
            </Grid>
            <Grid item xs={3} md={3} />
          </Grid>
        ) : null}

        {visibleDatos ? (
          <Fragment>
            <h2 style={{ textAlign: "center" }}>Datos del Paciente</h2>
            <Grid container spacing={0} style={{ padding: "0" }}>
              <Grid
                item
                xs={11}
                md={11}
                style={{ marginLeft: "1vw", marginTop: "2vw" }}
              >
                <TextField
                  value={
                    servicioTelemedicina ? servicioTelemedicina.nombre : null
                  }
                  id="nombre"
                  label="Apellido y Nombre"
                  fullWidth
                  variant="standard"
                  disabled
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "black",
                    },
                  }}
                />
              </Grid>
              <Grid
                item
                xs={11}
                md={11}
                style={{ marginLeft: "1vw", marginTop: "2vw" }}
              >
                <TextField
                  value={
                    servicioTelemedicina ? servicioTelemedicina.domicilio : null
                  }
                  id="domicilio"
                  label="Domicilio"
                  fullWidth
                  variant="standard"
                  disabled
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "black",
                    },
                  }}
                />
              </Grid>
              <Grid
                item
                xs={2}
                md={2}
                style={{ marginLeft: "1vw", marginTop: "2vw" }}
              >
                <TextField
                  value={
                    servicioTelemedicina ? servicioTelemedicina.edad : null
                  }
                  id="edad"
                  label="Edad"
                  fullWidth
                  variant="standard"
                  disabled
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "black",
                    },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={4}
                md={3}
                style={{ marginLeft: "1vw", marginTop: "2vw" }}
              >
                <TextField
                  value={
                    servicioTelemedicina ? servicioTelemedicina.celular : null
                  }
                  id="celular"
                  label="Celular"
                  fullWidth
                  variant="standard"
                  disabled
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "black",
                    },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={4}
                style={{
                  marginLeft: "1vw",
                  marginRight: "1vw",
                  marginTop: "0vw",
                }}
              >
                <h4>Observaciones</h4>
                <TextareaAutosize
                  id="observaciones"
                  maxRows={5}
                  minRows={5}
                  //value={afiliado.observaciones}
                  aria-label="maximum height"
                  placeholder="Observaciones"
                  defaultValue={
                    notas && notas.length > 0 ? notas[0].nota : null
                  }
                  style={{ width: "-webkit-fill-available", marginTop: "0em" }}
                  disabled
                  /*
                              onChange={(e) =>
                                guardarAfiliado({
                                  ...afiliado,
                                  observaciones: e.target.value,
                                })
                              }
                              */
                />
              </Grid>

              <Grid item xs={12} md={12} />
              <Grid item xs={4} md={4} />
              <Grid item xs={4} md={4}>
                <Button
                  label="Volver"
                  icon="pi pi-arrow-left"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-danger"
                  onClick={() => {
                    setVisibleDatos(false);
                    setVisibleReceta1(false);
                    setVisibleReceta2(false);
                  }}
                />
              </Grid>
              <Grid item xs={4} md={4} />
            </Grid>
          </Fragment>
        ) : null}

        {visibleReceta1 ? (
          <Fragment>
            <h2 style={{ textAlign: "center" }}>Receta</h2>
            <Grid container spacing={0} style={{ padding: "0" }}>
              <div className="flex flex-column h-12rem">
                <div className="flex pt-4 justify-content-end">
                  <Grid container spacing={0} style={{ marginTop: "0vw" }}>
                    <Grid
                      item
                      xs={11}
                      md={5}
                      style={{ marginLeft: "1vw", marginTop: "1vw" }}
                    >
                      <TextField
                        value={
                          servicioTelemedicina
                            ? servicioTelemedicina.apellido
                            : null
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                        id="Apellido"
                        label="Apellido"
                        fullWidth
                        variant="standard"
                        onChange={(e) =>
                          guardarServicioTelemedicina({
                            ...servicioTelemedicina,
                            apellido: e.target.value,
                          })
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      xs={11}
                      md={5}
                      style={{ marginLeft: "1vw", marginTop: "1vw" }}
                    >
                      <TextField
                        value={
                          servicioTelemedicina
                            ? servicioTelemedicina.nombres
                            : null
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                        id="Nombre"
                        label="Nombre"
                        fullWidth
                        variant="standard"
                        onChange={(e) =>
                          guardarServicioTelemedicina({
                            ...servicioTelemedicina,
                            nombres: e.target.value,
                          })
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      xs={3}
                      md={2}
                      style={{ marginLeft: "1vw", marginTop: "1vw" }}
                    >
                      <TextField
                        value={
                          servicioTelemedicina
                            ? servicioTelemedicina.numeroDocumento
                            : null
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                        id="numeroDocumento"
                        label="D.N.I."
                        fullWidth
                        variant="standard"
                        onChange={(e) =>
                          guardarServicioTelemedicina({
                            ...servicioTelemedicina,
                            numeroDocumento: e.target.value,
                          })
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      xs={5}
                      md={2}
                      style={{ marginLeft: "1vw", marginTop: "1vw" }}
                    >
                      <TextField
                        id="nacimiento"
                        label="Fecha Nacimiento"
                        type="date"
                        variant="standard"
                        value={
                          servicioTelemedicina
                            ? servicioTelemedicina.nacimiento
                            : null
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                        onChange={(e) => {
                          guardarServicioTelemedicina({
                            ...servicioTelemedicina,
                            nacimiento: e.target.value,
                          });
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={2}
                      md={2}
                      style={{ marginLeft: "0vw", marginTop: "2vw" }}
                    >
                      <Dropdown
                        value={
                          servicioTelemedicina && servicioTelemedicina.sexo
                            ? sexos[
                                sexos.findIndex(
                                  (element) =>
                                    element.nombre === servicioTelemedicina.sexo
                                )
                              ]
                            : null
                        }
                        onChange={(e) => {
                          if (e.value) {
                            guardarServicioTelemedicina({
                              ...servicioTelemedicina,
                              sexo: e.value.nombre,
                            });
                          } else {
                            guardarServicioTelemedicina({
                              ...servicioTelemedicina,
                              sexo: null,
                            });
                          }
                        }}
                        options={sexos}
                        optionLabel="nombre"
                        showClear
                        placeholder="Seleccione un sexo"
                        className="w-full md:w-14rem"
                        style={{ marginLeft: "1vw", marginTop: ".75vw" }}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={4}
                      style={{ marginLeft: "1vw", marginTop: "1vw" }}
                    >
                      <label htmlFor="id">Obra Social: </label>

                      <Dropdown
                        value={
                          obrasSocialesMedicas &&
                          servicioTelemedicina &&
                          servicioTelemedicina.obraSocial
                            ? obrasSocialesMedicas[
                                obrasSocialesMedicas.findIndex(
                                  (element) =>
                                    element.name ===
                                    servicioTelemedicina.obraSocial
                                )
                              ]
                            : null
                        }
                        onChange={(e) => {
                          if (e.value) {
                            guardarServicioTelemedicina({
                              ...servicioTelemedicina,
                              obraSocial: e.value.name,
                            });
                          } else {
                            guardarServicioTelemedicina({
                              ...servicioTelemedicina,
                              obraSocial: null,
                            });
                          }
                        }}
                        options={obrasSocialesMedicas}
                        optionLabel="name"
                        showClear
                        filter
                        placeholder="Seleccione obra social"
                        className="w-75"
                        style={{ marginLeft: "1vw", marginTop: ".75vw" }}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      md={3}
                      style={{ marginLeft: "1vw", marginTop: "1vw" }}
                    >
                      <TextField
                        value={
                          servicioTelemedicina
                            ? servicioTelemedicina.nroObraSocial
                            : null
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        id="numeroObraSocial"
                        label="Nº Obra Social"
                        fullWidth
                        variant="standard"
                        onChange={(e) =>
                          guardarServicioTelemedicina({
                            ...servicioTelemedicina,
                            nroObraSocial: e.target.value,
                          })
                        }
                      />
                    </Grid>

                    {/*    
                    <Grid item size={{ xs: 12, md: 8 }}>
                      <TextField
                        value={
                          servicioTelemedicina
                            ? pacienteSeleccionado.email
                            : null
                        }
                        slotProps={{
                          inputLabel: {
                            shrink: true,
                          },
                        }}
                        id="email"
                        label="Correo Electrónico"
                        fullWidth
                        variant="standard"
                        onChange={(e) => {
                          if (e.target.value) {
                            guardarPacienteSeleccionado({
                              ...pacienteSeleccionado,
                              email: e.target.value,
                              enviarCorreo: true,
                            });
                          } else {
                            guardarPacienteSeleccionado({
                              ...pacienteSeleccionado,
                              email: null,
                              enviarCorreo: false,
                            });
                          }
                        }}
                      />
                    </Grid>
                    */}

                    <Grid
                      item
                      xs={5}
                      md={4}
                      style={{ marginLeft: "1vw", marginTop: "1vw" }}
                    >
                      <TextField
                        value={
                          servicioTelemedicina
                            ? servicioTelemedicina.celular
                            : null
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        id="telefono"
                        label="Celular"
                        fullWidth
                        variant="standard"
                        onChange={(e) => {
                          if (e.target.value) {
                            guardarServicioTelemedicina({
                              ...servicioTelemedicina,
                              celular: e.target.value,
                            });
                          } else {
                            guardarServicioTelemedicina({
                              ...servicioTelemedicina,
                              celular: null,
                            });
                          }
                        }}
                      />
                    </Grid>

                    {/*      
                    <Grid
                      item
                      size={{ xs: 5, md: 2 }}
                      sx={{ marginRight: "0.5em" }}
                    >
                      <FormControlLabel
                        value="yes"
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              servicioTelemedicina
                                ? pacienteSeleccionado.enviarCorreo
                                : null
                            }
                            style={{ marginLeft: "0.5em" }}
                            onChange={(e) =>
                              guardarPacienteSeleccionado({
                                ...pacienteSeleccionado,
                                enviarCorreo: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Enviar Correo"
                        labelPlacement="start"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={2}
                      sx={{ marginRight: "0.5em" }}
                      style={{ marginLeft: "1vw", marginTop: "1vw" }}
                    >
                      <FormControlLabel
                        value="yes"
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              servicioTelemedicina
                                ? servicioTelemedicina.enviarWhatsApp
                                : false
                            }
                            style={{ marginLeft: "0.5em" }}
                            onChange={(e) =>
                              guardarServicioTelemedicina({
                                ...servicioTelemedicina,
                                enviarWhatsApp: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Enviar WhatsApp"
                        labelPlacement="start"
                      />
                    </Grid>
                    */}

                    <Grid item xs={12} md={12} />
                  </Grid>
                </div>
              </div>

              <Grid item xs={2} md={2} />
              <Grid item xs={4} md={4}>
                <Button
                  label="Siguiente"
                  icon="pi pi-arrow-right"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-success"
                  onClick={() => {
                    // Validar
                    if (
                      servicioTelemedicina &&
                      (!servicioTelemedicina.apellido ||
                        servicioTelemedicina.apellido === "")
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar apellido.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      servicioTelemedicina &&
                      (!servicioTelemedicina.nombres ||
                        servicioTelemedicina.nombres === "")
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar nombre.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      servicioTelemedicina &&
                      (!servicioTelemedicina.numeroDocumento ||
                        servicioTelemedicina.numeroDocumento === "")
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar nro de documento.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      servicioTelemedicina &&
                      (!servicioTelemedicina.nacimiento ||
                        servicioTelemedicina.nacimiento === "")
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar fecha de nacimiento.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      servicioTelemedicina &&
                      (!servicioTelemedicina.sexo ||
                        servicioTelemedicina.sexo === "")
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar sexo.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      servicioTelemedicina &&
                      (!servicioTelemedicina.obraSocial ||
                        servicioTelemedicina.obraSocial === "")
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar obra social.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      servicioTelemedicina &&
                      (!servicioTelemedicina.nroObraSocial ||
                        servicioTelemedicina.nroObraSocial === "")
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar nro de obra social.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      servicioTelemedicina &&
                      (!servicioTelemedicina.celular ||
                        servicioTelemedicina.celular === "")
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar nro de celular.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      servicioTelemedicina &&
                      servicioTelemedicina.celular &&
                      servicioTelemedicina.celular.length !== 10
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "El celular debe tener 10 dígitos.",
                        life: 3000,
                      });
                      return;
                    }

                    guardarServicioTelemedicina({
                      ...servicioTelemedicina,
                      tratamientoProlongado: false,
                      duplicado: false,
                      respetarMarca: false,
                    });

                    setVisibleReceta1(false);
                    setVisibleReceta2(true);
                  }}
                />
              </Grid>
              <Grid item xs={4} md={4}>
                <Button
                  label="Volver"
                  icon="pi pi-arrow-left"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-danger"
                  onClick={() => {
                    setVisibleReceta1(false);
                    setVisibleReceta2(false);
                  }}
                />
              </Grid>
              <Grid item xs={2} md={2} />
            </Grid>
          </Fragment>
        ) : null}

        {visibleReceta2 ? (
          <Fragment>
            <h2 style={{ textAlign: "center" }}>Receta</h2>
            <Grid container spacing={0} style={{ padding: "0" }}>
              <Grid
                item
                xs={6}
                md={3}
                style={{ marginLeft: "2vw", marginTop: "1vw" }}
              >
                <TextField
                  id="fecha"
                  label="Fecha"
                  type="date"
                  variant="standard"
                  disabled
                  value={
                    servicioTelemedicina && servicioTelemedicina.fpasado
                      ? formatDate(servicioTelemedicina.fpasado)
                      : null
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                  /*
                  onChange={(e) => {
                    guardarServicioTelemedicina({
                      ...servicioTelemedicina,
                      fecha: e.target.value,
                    });
                  }}
                  */
                />
              </Grid>

              <Grid
                item
                xs={11}
                md={8}
                style={{
                  marginLeft: "2vw",
                  marginTop: "1vw",
                  marginBottom: "2vw",
                }}
              >
                <TextField
                  id="diagnostico"
                  label="Diagnóstico"
                  variant="standard"
                  value={
                    servicioTelemedicina
                      ? servicioTelemedicina.detalleDiagnostico
                      : null
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled
                  required
                  /*
                  onChange={(e) => {
                    guardarServicioTelemedicina({
                      ...servicioTelemedicina,
                      diagnostico: e.target.value,
                    });
                  }}
                  */
                />
              </Grid>

              <Grid
                item
                xs={3.8}
                md={2}
                style={{ marginLeft: "1vw", marginTop: "1vw" }}
              >
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      color="primary"
                      checked={
                        servicioTelemedicina
                          ? servicioTelemedicina.tratamientoProlongado
                          : false
                      }
                      style={{ marginLeft: "0.5em" }}
                      onChange={(e) =>
                        guardarServicioTelemedicina({
                          ...servicioTelemedicina,
                          tratamientoProlongado: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Tratamiento Prolongado"
                  labelPlacement="start"
                />
              </Grid>
              <Grid
                item
                xs={3.8}
                md={2}
                style={{ marginLeft: "1vw", marginTop: "1vw" }}
              >
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      color="primary"
                      checked={
                        servicioTelemedicina
                          ? servicioTelemedicina.duplicado
                          : false
                      }
                      style={{ marginLeft: "0.5em" }}
                      onChange={(e) =>
                        guardarServicioTelemedicina({
                          ...servicioTelemedicina,
                          duplicado: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Duplicado"
                  labelPlacement="start"
                />
              </Grid>
              <Grid
                item
                xs={3.8}
                md={2}
                style={{ marginLeft: "1vw", marginTop: "1vw" }}
              >
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      color="primary"
                      checked={
                        servicioTelemedicina
                          ? servicioTelemedicina.respetarMarca
                          : false
                      }
                      style={{ marginLeft: "0.5em" }}
                      onChange={(e) =>
                        guardarServicioTelemedicina({
                          ...servicioTelemedicina,
                          respetarMarca: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Respetar Marca"
                  labelPlacement="start"
                />
              </Grid>
              <Grid item xs={12} md={12} />

              <Grid
                item
                xs={12}
                md={5}
                style={{
                  marginLeft: "1vw",
                  marginTop: "2vw",
                }}
              >
                <Dropdown
                  value={medicamentoElegido}
                  onChange={(e) => {
                    setMedicamentoElegido(e.value);
                    setPresentacionElegida(null);
                  }}
                  options={medicamentos}
                  optionLabel="detalle"
                  placeholder="Seleccione un medicamento"
                  filter
                  showClear
                  className="w-75"
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={5}
                style={{
                  marginLeft: "1vw",
                  marginTop: "2vw",
                }}
              >
                <Dropdown
                  value={presentacionElegida}
                  onChange={(e) => {
                    if (e.value) {
                      setPresentacionElegida(e.value);
                    } else {
                      setPresentacionElegida(null);
                    }
                  }}
                  options={
                    presentaciones &&
                    presentaciones.length > 0 &&
                    medicamentoElegido
                      ? presentaciones.filter(
                          (element) => element.id === medicamentoElegido.id
                        )
                      : null
                  }
                  disabled={!medicamentoElegido}
                  optionLabel="presentacion"
                  showClear
                  placeholder="Seleccione una Presentación"
                  className="w-full md:w-14rem"
                />
              </Grid>

              <Grid
                item
                xs={4}
                md={2}
                style={{ marginLeft: "1vw", marginTop: "2vw" }}
              >
                <TextField
                  value={cantidadMedicamento ? cantidadMedicamento : ""}
                  type="number"
                  required
                  id="cantidad"
                  label="Cantidad"
                  disabled={!presentacionElegida}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setCantidadMedicamento(e.target.value);
                  }}
                />
              </Grid>

              <div className="flex pt-4 justify-content-between">
                <Button
                  label="Agregar"
                  severity="success"
                  icon="pi pi-check"
                  className="p-button-rounded p-button-success"
                  style={{
                    marginRight: "1vw",
                    marginTop: "2vw",
                    marginLeft: "1vw",
                    marginBottom: "1vw",
                  }}
                  onClick={() => {
                    if (!medicamentoElegido) {
                      toast.current.show({
                        severity: "info",
                        summary: "Receta",
                        detail: "Debe seleccionar un medicamento.",
                        life: 3000,
                      });
                      return;
                    }
                    if (!presentacionElegida) {
                      toast.current.show({
                        severity: "info",
                        summary: "Receta",
                        detail: "Debe seleccionar una presentacion.",
                        life: 3000,
                      });
                      return;
                    }
                    if (
                      !cantidadMedicamento ||
                      Number(cantidadMedicamento) <= 0
                    ) {
                      toast.current.show({
                        severity: "info",
                        summary: "Receta",
                        detail: "Debe seleccionar una cantidad.",
                        life: 3000,
                      });
                      return;
                    }

                    agregarMedicamento();
                  }}
                />
                <Button
                  id="cancelarMedicamento"
                  label="Cancelar"
                  severity="danger"
                  icon="pi pi-times"
                  className="p-button-rounded p-button-help"
                  iconPos="right"
                  style={{
                    marginBottom: "1vw",
                  }}
                  onClick={() => {
                    setMedicamentoElegido(null);
                    setPresentacionElegida(null);
                    setCantidadMedicamento(null);
                    guardarServicioTelemedicina({
                      ...servicioTelemedicina,
                      tratamientoProlongado: false,
                      duplicado: false,
                      respetarMarca: false,
                    });
                  }}
                />
              </div>

              <Grid item xs={12} md={12} />

              <Grid
                item
                xs={11}
                md={11}
                style={{ marginLeft: "1vw", marginTop: "5vw" }}
              >
                <DataTable
                  value={medicamentosRecetas}
                  size={"small"}
                  tableStyle={{ minWidth: "50rem" }}
                  style={{ marginLeft: "1vw" }}
                  emptyMessage="No hay datos"
                >
                  <Column field="medicamento" header="Medicamento"></Column>
                  <Column field="presentacion" header="Presentación"></Column>
                  <Column field="cantidad" header="Cantidad"></Column>
                  <Column
                    field="prolongado"
                    header="T. Prolongado"
                    body={prolongadoTemplate}
                  ></Column>
                  <Column
                    field="duplicado"
                    header="Duplicado"
                    body={duplicadoTemplate}
                  ></Column>
                  <Column
                    field="respetar"
                    header="Respetar Marca"
                    body={respetarTemplate}
                  ></Column>
                  <Column
                    style={{ flex: "0 0 4rem" }}
                    body={itemTemplate}
                  ></Column>
                </DataTable>
              </Grid>

              <Grid item xs={2} md={2} />
              <Grid item xs={4} md={4}>
                <Button
                  label="Generar"
                  icon="pi pi-arrow-right"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-success"
                  onClick={() => {
                    if (
                      !servicioTelemedicina ||
                      servicioTelemedicina.fpasado === undefined ||
                      servicioTelemedicina.fpasado === null ||
                      servicioTelemedicina.fpasado.trim() === ""
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar una fecha.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      servicioTelemedicina &&
                      (!servicioTelemedicina.detalleDiagnostico ||
                        servicioTelemedicina.detalleDiagnostico === "")
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar un diagnóstico.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      !medicamentosRecetas ||
                      medicamentosRecetas.length <= 0
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Receta",
                        detail: "Debe ingresar un medicamento.",
                        life: 3000,
                      });
                      return;
                    }

                    setVisibleDatos(false);
                    setVisibleReceta1(false);
                    setVisibleReceta2(false);
                    aceptarClick();
                  }}
                />
              </Grid>
              <Grid item xs={4} md={4}>
                <Button
                  label="Volver"
                  icon="pi pi-arrow-left"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-danger"
                  onClick={() => {
                    setVisibleReceta2(false);
                    setVisibleReceta1(true);
                  }}
                />
              </Grid>

              <Grid item xs={2} md={2} />
            </Grid>
          </Fragment>
        ) : null}

        {visibleIndicaciones ? (
          <Fragment>
            <h2 style={{ textAlign: "center" }}>Indicaciones</h2>
            <Grid container spacing={0} style={{ padding: "0" }}>
              <Grid
                item
                xs={11}
                md={4}
                style={{
                  marginLeft: "2vw",
                  marginRight: "2vw",
                  marginTop: "2vw",
                }}
              >
                <h4>Indicaciones</h4>
                <TextareaAutosize
                  id="indicaciones"
                  maxRows={5}
                  minRows={5}
                  //value={afiliado.observaciones}
                  aria-label="maximum height"
                  placeholder="Indicaciones"
                  defaultValue={
                    servicioTelemedicina && servicioTelemedicina.indicaciones
                      ? servicioTelemedicina.indicaciones
                      : null
                  }
                  style={{ width: "-webkit-fill-available", marginTop: "0em" }}
                  onChange={(e) => {
                    guardarServicioTelemedicina({
                      ...servicioTelemedicina,
                      indicaciones: e.target.value,
                    });
                    verificarReposo(e.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} />
              <Grid item xs={2} md={2} />
              <Grid item xs={4} md={4}>
                <Button
                  label="Aceptar"
                  icon="pi pi-check"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-success"
                  onClick={() => {
                    if (
                      servicioTelemedicina &&
                      !servicioTelemedicina.indicaciones
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Indicaciones",
                        detail: "Debe ingresar las indicaciones.",
                        life: 3000,
                      });
                      return;
                    }

                    localStorage.setItem(
                      "indicaciones",
                      servicioTelemedicina.indicaciones
                    );
                    generarIndicacionesTelemedicina({
                      servicioTelemedicina,
                      medico,
                    });
                    setVisibleIndicaciones(false);
                  }}
                />
              </Grid>
              <Grid item xs={4} md={4}>
                <Button
                  label="Volver"
                  icon="pi pi-arrow-left"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-danger"
                  onClick={() => {
                    setVisibleReceta1(false);
                    setVisibleReceta2(false);
                    setVisibleIndicaciones(false);
                  }}
                />
              </Grid>

              <Grid item xs={2} md={2} />
            </Grid>
          </Fragment>
        ) : null}

        {visibleDiagnostico ? (
          <Fragment>
            <h2 style={{ textAlign: "center" }}>Diagnóstico</h2>
            <Grid container spacing={0} style={{ padding: "0" }}>
              <Grid
                item
                xs={11}
                md={5}
                style={{ marginLeft: "2vw", marginTop: "1vw" }}
              >
                <Autocomplete
                  id="diagnostico"
                  fullWidth
                  options={diagnosticos}
                  disablePortal
                  //defaultValue={colores[idColorDefault]}
                  defaultValue={
                    servicioTelemedicina &&
                    servicioTelemedicina.diagnosticoId &&
                    servicioTelemedicina.diagnosticoId !== undefined
                      ? diagnosticos[
                          diagnosticos.findIndex(
                            (item) =>
                              item.id === servicioTelemedicina.diagnosticoId
                          )
                        ]
                      : null
                  }
                  getOptionLabel={(option) => option.nombre}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Diagnóstico"
                      variant="standard"
                    />
                  )}
                  //onKeyDown={handleEnter}
                  onChange={(event, value) => {
                    if (value) {
                      let elem = acMotivo.current.getElementsByClassName(
                        "MuiAutocomplete-clearIndicator"
                      )[0];
                      if (elem) {
                        elem.click();
                      }
                      guardarServicioTelemedicina({
                        ...servicioTelemedicina,
                        diagnosticoId: value.id,
                      });
                    } else {
                      guardarServicioTelemedicina({
                        ...servicioTelemedicina,
                        diagnosticoId: null,
                      });
                      let elem = acMotivo.current.getElementsByClassName(
                        "MuiAutocomplete-clearIndicator"
                      )[0];
                      if (elem) {
                        elem.click();
                      }
                    }
                  }}
                />
              </Grid>

              <Grid
                item
                xs={11}
                md={5}
                style={{ marginLeft: "2vw", marginTop: "1vw" }}
              >
                <Autocomplete
                  id="motivoConsulta"
                  ref={acMotivo}
                  fullWidth
                  options={
                    motivosConsultas
                      ? motivosConsultas.filter(
                          (element) =>
                            element.color === "ROJO" ||
                            element.color === "VERDE" ||
                            element.color === "AMARILLO"
                        )
                      : null
                  }
                  disablePortal
                  //defaultValue={colores[idColorDefault]}
                  defaultValue={
                    servicioTelemedicinaNuevo &&
                    servicioTelemedicinaNuevo.motivoConsultaId &&
                    servicioTelemedicinaNuevo.motivoConsultaId !== undefined
                      ? motivosConsultas.findIndex(
                          (item) =>
                            item.id ===
                            servicioTelemedicinaNuevo.motivoConsultaId
                        ) !== -1
                        ? motivosConsultas[
                            motivosConsultas.findIndex(
                              (item) =>
                                item.id ===
                                servicioTelemedicinaNuevo.motivoConsultaId
                            )
                          ]
                        : null
                      : null
                  }
                  getOptionLabel={(option) => option.nombre}
                  renderOption={(props, option) => {
                    const { nombre, codColor } = option;
                    return (
                      <li
                        {...props}
                        style={{
                          backgroundColor: codColor,
                          color:
                            codColor === "#FFFF00" ||
                            codColor === "#FFFFFF" ||
                            codColor === "#00FFFF"
                              ? "#000000"
                              : "#FFFFFF",
                        }}
                      >
                        {nombre}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Motivo de Consulta"
                      variant="standard"
                    />
                  )}
                  //onKeyDown={handleEnter}
                  onChange={(event, value) => {
                    if (value) {
                      guardarServicioTelemedicinaNuevo({
                        ...servicioTelemedicinaNuevo,
                        motivoConsultaId: value.id,
                        color: value.color,
                      });
                    } else {
                      guardarServicioTelemedicinaNuevo({
                        ...servicioTelemedicinaNuevo,
                        motivoConsultaId: null,
                        color: null,
                      });
                    }
                  }}
                  disabled={
                    (servicioTelemedicina &&
                      servicioTelemedicina.diagnosticoId &&
                      diagnosticos &&
                      diagnosticos.find(
                        (item) => item.id === servicioTelemedicina.diagnosticoId
                      ).nombre !== motivoEnvio) ||
                    !servicioTelemedicina.diagnosticoId
                  }
                />
              </Grid>

              <Grid
                item
                xs={11}
                md={11}
                style={{
                  marginLeft: "2vw",
                  marginRight: "2vw",
                  marginTop: "2vw",
                }}
              >
                <h4>Detalle</h4>
                <TextareaAutosize
                  id="detalle"
                  maxRows={5}
                  minRows={5}
                  //value={afiliado.observaciones}
                  aria-label="maximum height"
                  placeholder="Detalle"
                  defaultValue={
                    servicioTelemedicina &&
                    servicioTelemedicina.detalleDiagnostico
                      ? servicioTelemedicina.detalleDiagnostico
                      : null
                  }
                  style={{ width: "-webkit-fill-available", marginTop: "0em" }}
                  onChange={(e) =>
                    guardarServicioTelemedicina({
                      ...servicioTelemedicina,
                      detalleDiagnostico: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={12} />
              <Grid item xs={2} md={2} />
              <Grid item xs={4} md={4}>
                <Button
                  label="Aceptar"
                  icon="pi pi-check"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-success"
                  onClick={() => {
                    if (
                      servicioTelemedicina &&
                      !servicioTelemedicina.diagnosticoId
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Diagnóstico",
                        detail: "Debe ingresar el diagnóstico.",
                        life: 3000,
                      });
                      return;
                    }

                    if (
                      servicioTelemedicina &&
                      !servicioTelemedicina.detalleDiagnostico
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Detalle Diagnóstico",
                        detail: "Debe ingresar el detalle del diagnóstico.",
                        life: 3000,
                      });
                      return;
                    }

                    let motivo = diagnosticos.find(
                      (item) => item.id === servicioTelemedicina.diagnosticoId
                    ).nombre;

                    if (
                      servicioTelemedicina &&
                      motivo === motivoEnvio &&
                      (!servicioTelemedicinaNuevo ||
                        !servicioTelemedicinaNuevo.motivoConsultaId)
                    ) {
                      toast.current.show({
                        severity: "warn",
                        summary: "Telemedicina",
                        detail:
                          "Debe cargar un motivo de consulta para este diagnóstico.",
                        life: 3000,
                      });
                      return;
                    }

                    localStorage.setItem(
                      "diagnosticoId",
                      servicioTelemedicina.diagnosticoId
                    );
                    localStorage.setItem(
                      "detalleDiagnostico",
                      servicioTelemedicina.detalleDiagnostico
                    );
                    localStorage.setItem(
                      "motivoConsultaId",
                      servicioTelemedicinaNuevo.motivoConsultaId
                    );
                    setVisibleReceta1(false);
                    setVisibleReceta2(false);
                    setVisibleDiagnostico(false);
                  }}
                />
              </Grid>
              <Grid item xs={4} md={4}>
                <Button
                  label="Volver"
                  icon="pi pi-arrow-left"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-danger"
                  onClick={() => {
                    guardarServicioTelemedicina({
                      ...servicioTelemedicina,
                      diagnosticoId: null,
                      motivoConsultaId: null,
                      color: null,
                    });
                    let elem = acMotivo.current.getElementsByClassName(
                      "MuiAutocomplete-clearIndicator"
                    )[0];
                    if (elem) {
                      elem.click();
                    }
                    localStorage.removeItem("diagnosticoId");
                    localStorage.removeItem("motivoConsultaId");

                    setVisibleReceta1(false);
                    setVisibleReceta2(false);
                    setVisibleDiagnostico(false);
                  }}
                />
              </Grid>
              <Grid item xs={2} md={2} />
            </Grid>
          </Fragment>
        ) : null}

        {visibleGestion ? (
          <Fragment>
            <h2 style={{ textAlign: "center" }}>Recetas - Indicaciones</h2>
            <Grid container spacing={0} style={{ padding: "0" }}>
              {/*
              <Grid
                item
                xs={11}
                md={11}
                style={{ marginLeft: "1vw", marginTop: "5vw" }}
              >
                <DataTable
                  value={recetas}
                  size={"small"}
                  tableStyle={{ minWidth: "50rem" }}
                  style={{ marginLeft: "1vw" }}
                  emptyMessage="No hay datos"
                >
                  <Column field="id" header="ID"></Column>
                  <Column field="fecha" header="Fecha"></Column>
                  <Column field="tipo" header="Tipo"></Column>
                </DataTable>
              </Grid>
              */}

              <div className="card">
                <DataView
                  value={recetas}
                  itemTemplate={itemTemplateGestion}
                  layout="grid"
                  emptyMessage="No hay datos."
                />
              </div>

              <Grid item xs={12} md={12} />
              <Grid item xs={12} md={12} />
              <Grid item xs={2} md={2} />
              <Grid item xs={4} md={4}>
                <Button
                  label="Enviar"
                  icon="pi pi-send"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  disabled={recetas && recetas.length === 0}
                  className="p-button-info"
                  onClick={() => {
                    setVisibleDatos(false);
                    setVisibleReceta1(false);
                    setVisibleReceta2(false);
                    setVisibleGestion(false);
                    confirmarEnviar();
                  }}
                />
              </Grid>
              <Grid item xs={4} md={4}>
                <Button
                  label="Volver"
                  icon="pi pi-arrow-left"
                  style={{
                    marginLeft: "2vw",
                    marginTop: "5vw",
                  }}
                  className="p-button-danger"
                  onClick={() => {
                    setVisibleDatos(false);
                    setVisibleReceta1(false);
                    setVisibleReceta2(false);
                    setVisibleGestion(false);
                  }}
                />
              </Grid>

              <Grid item xs={2} md={2} />
            </Grid>
          </Fragment>
        ) : null}
      </Fragment>
    </Fragment>
  );
}
